import {
  ScreenClient,
  CreateScreenDTO,
  PlateClient,
  ScreenDetailsInfoDTO,
  ScreenNodeInfoDTO,
  FragmentScreenNodeInfoDTO,
  RotateScreenDTO,
  ScreenRepairInfoDTO,
} from 'business/models/Models';
import ModelFactory from 'business/models/ModelFactory';
import BaseService from './BaseService';
import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import { getPlainExperiment } from 'transformers/experiment';
import { ResponseDTO } from '../models/Models';

export default class ScreenService extends BaseService {
  async createScreen(treeNodeId: number) {
    const screenClient: ScreenClient = ModelFactory(ScreenClient, false, true);
    const createScreenDTO: CreateScreenDTO = new CreateScreenDTO();
    createScreenDTO.parentTreeNodeId = treeNodeId;
    return await screenClient.createScreen(createScreenDTO);
  }

  async rotateScreen(rotateScreenDTOList: RotateScreenDTO[]) {
    const screenClient: ScreenClient = ModelFactory(ScreenClient, false, true);
    return await screenClient.rotateScreen(rotateScreenDTOList);
  }

  async getScreenById(expId: number, signal?: AbortSignal): Promise<ExperimentDtoClient> {
    const client: PlateClient = ModelFactory(PlateClient, undefined, true, signal);
    return getPlainExperiment(await client.getScreenByPlateId(expId));
  }

  async getScreenInfoByName(screenName: string): Promise<ScreenDetailsInfoDTO> {
    const client: ScreenClient = ModelFactory(ScreenClient, undefined, true);
    return client.getScreenDetailsByScreenName(screenName);
  }

  async getScreenNodeInfo(treeNodeId: number): Promise<ScreenNodeInfoDTO[]> {
    const screenClient: ScreenClient = ModelFactory(ScreenClient, false, true);
    return screenClient.getScreenNodeInfo(treeNodeId);
  }

  async getFragmentScreenNodeInfo(
    treeNodeId: number,
  ): Promise<FragmentScreenNodeInfoDTO> {
    const screenClient: ScreenClient = ModelFactory(ScreenClient, false, true);
    return screenClient.getFragmentScreenNodeInfo(treeNodeId);
  }

  async getScreenRepairInfo(screenId: number): Promise<ScreenRepairInfoDTO> {
    const screenClient: ScreenClient = ModelFactory(ScreenClient, false, true);
    return screenClient.getScreenRepairInfo(screenId);
  }

  async checkScreenLotInUse(screenLotId: number): Promise<ResponseDTO> {
    const screenClient: ScreenClient = ModelFactory(ScreenClient, false, true);
    return screenClient.checkScreenLotInUse(screenLotId);
  }
}
